
import React, { useState, useRef, useEffect } from "react";
import Modal from "react-modal";
import { FaShoppingCart , FaTrash} from "react-icons/fa";

Modal.setAppElement("#root");

const initialCart = [
  {
    id: 1,
    restaurantName: "Mama's Kitchen",
    name: "Maamaas Package",
    packageType: "Veg",
    price: 250,
    qty: 2,
    image: "https://via.placeholder.com/100x100/f8f9fa/6c757d?text=Veg+Meal"
  },
  {
    id: 2,
    restaurantName: "Spice House",
    name: "HFC Package",
    packageType: "Non-Veg",
    price: 400,
    qty: 1,
    image: "https://via.placeholder.com/100x100/f8f9fa/6c757d?text=NonVeg+Meal"
  },

];

export default function CateringCartFullPage() {
  const [cartItems, setCartItems] = useState(initialCart);
  const [isOrdered, setIsOrdered] = useState(false);
  const [isScheduled, setIsScheduled] = useState(false);
  const [isScheduleModalOpen, setIsScheduleModalOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedTime, setSelectedTime] = useState("");
  const [savedSchedule, setSavedSchedule] = useState(null);
  const [showPaymentOptions, setShowPaymentOptions] = useState(false);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);
  const [paymentMode, setPaymentMode] = useState("full");
  const [partialAmount, setPartialAmount] = useState("");
  const [paymentCompleted, setPaymentCompleted] = useState(false);
  const [remainingAmount, setRemainingAmount] = useState(0);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const paymentSectionRef = useRef(null);

  const platformCharges = 20.0;
  const deliveryCharges = 50.0;
  const gstPercent = 18;
  const [discountApplied, setDiscountApplied] = useState(false);

  // Update window width on resize
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Update qty
  const updateQty = (id, delta) => {
    setCartItems((prev) =>
      prev.map((p) =>
        p.id === id ? { ...p, qty: Math.max(1, p.qty + delta) } : p
      )
    );
  };

  const removeItem = (id) => setCartItems((prev) => prev.filter((i) => i.id !== id));

  // Subtotal calculations
  const subTotal = cartItems.reduce((s, i) => s + i.price * i.qty, 0);
  const discountAmount = discountApplied ? +(subTotal * 0.1).toFixed(2) : 0;
  const taxableAmount = Math.max(0, subTotal - discountAmount);
  const gstAmount = +(taxableAmount * (gstPercent / 100)).toFixed(2);
  const cgst = +(gstAmount / 2).toFixed(2);
  const sgst = +(gstAmount - cgst).toFixed(2);
  const totalBeforePayment =
    taxableAmount + platformCharges + deliveryCharges + gstAmount;
  const grandTotal = +totalBeforePayment.toFixed(2);

  useEffect(() => {
    setRemainingAmount((prevRem) => (!paymentCompleted ? grandTotal : prevRem));
  }, [grandTotal, paymentCompleted]);

  // Handlers
  const handleOrderNow = () => {
    setIsOrdered(true);
    setShowPaymentOptions(true);
    setTimeout(() => paymentSectionRef.current?.scrollIntoView({ behavior: "smooth" }), 150);
  };

  const openScheduleModal = () => { setIsScheduleModalOpen(true); setIsScheduled(true); };
  const closeScheduleModal = () => setIsScheduleModalOpen(false);

  const handleSaveSchedule = () => {
    if (!selectedDate || !selectedTime) return alert("Please select both date and time.");
    setSavedSchedule({ date: selectedDate, time: selectedTime });
    setIsScheduleModalOpen(false);
    setShowPaymentOptions(true);
    setTimeout(() => paymentSectionRef.current?.scrollIntoView({ behavior: "smooth" }), 150);
  };

  const selectPaymentMethod = (method) => {
    if (selectedPaymentMethod === method) {
      setSelectedPaymentMethod(null);
      setPaymentMode("full");
      setPartialAmount("");
    } else {
      setSelectedPaymentMethod(method);
      setPaymentMode("full");
      setPartialAmount("");
    }
  };

  const handlePayNow = () => {
    const payAmount = paymentMode === "full" ? remainingAmount || grandTotal : Number(partialAmount);
    if (!selectedPaymentMethod) return alert("Please select a payment method first.");
    if (paymentMode === "partial") {
      if (!partialAmount || Number(partialAmount) <= 0) return alert("Enter a valid partial amount.");
      if (Number(partialAmount) > (remainingAmount || grandTotal)) return alert("Partial amount cannot exceed remaining amount.");
    }
    const newRemaining = +((remainingAmount || grandTotal) - payAmount).toFixed(2);
    setRemainingAmount(newRemaining);
    setPaymentCompleted(newRemaining === 0);
    alert(`Payment successful for ₹${payAmount.toFixed(2)} using ${selectedPaymentMethod}.`);
  };

  const handlePlaceOrder = () => {
    if (!showPaymentOptions) return alert("Please choose Order Now or Schedule order first.");
    if ((remainingAmount || grandTotal) > 0 && !paymentCompleted) return alert("Please complete payment before placing order.");
    alert("Order placed successfully! Thank you.");
    setCartItems([]);
    setIsOrdered(false);
    setIsScheduled(false);
    setShowPaymentOptions(false);
    setSelectedPaymentMethod(null);
    setPaymentMode("full");
    setPartialAmount("");
    setPaymentCompleted(false);
    setRemainingAmount(0);
  };

  const clearCart = () => { if (window.confirm("Clear cart items?")) setCartItems([]); };

  // Responsive styles
  const isMobile = windowWidth < 768;

  const containerStyle = {
    fontFamily: "'Poppins', sans-serif",
    background: "linear-gradient(135deg, #ee6521 0%, #7d3fc2 100%)",
    minHeight: "100vh",
    borderRadius: "10px",
    padding: isMobile ? "16px" : "24px"
  };

  const headerStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    marginBottom: "20px",
    gap: "16px"
  };

  const cardStyle = {
    background: "#fff",
    padding: isMobile ? "16px" : "24px",
    borderRadius: "16px",
    boxShadow: "0 10px 30px rgba(0, 0, 0, 0.1)",
    marginBottom: "20px"
  };

  const buttonPrimaryStyle = {
    padding: "12px 24px",
    borderRadius: "50px",
    background: "linear-gradient(90deg, #ee6521, #7d3fc2)",
    color: "#fff",
    border: "none",
    cursor: "pointer",
    fontWeight: "600",
    fontSize: "16px",
    transition: "all 0.3s ease",
    boxShadow: "0 4px 15px rgba(177, 93, 198, 0.3)"
  };

  const buttonSecondaryStyle = {
    padding: "10px 22px",
    borderRadius: "50px",
    border: "2px solid #ee6521",
    background: "transparent",
    color: "#ee6521",
    cursor: "pointer",
    fontWeight: "600",
    fontSize: "16px",
    transition: "all 0.3s ease"
  };

  return (
    <div style={containerStyle}>
      {/* Header */}
      <div style={headerStyle}>
        <h1
          style={{
            color: "white",
            margin: 0,
            fontSize: isMobile ? "24px" : "32px",
            fontWeight: "700",
            textShadow: "0 2px 4px rgba(0,0,0,0.1)",
          }}
        >
          Catering Packages
        </h1>
        <button
          style={{
            padding: "10px 20px",
            borderRadius: "50px",
            background: "rgba(255, 255, 255, 0.2)",
            color: "#fff",
            border: "1px solid rgba(255, 255, 255, 0.3)",
            cursor: "pointer",
            fontWeight: "600",
            backdropFilter: "blur(10px)",
          }}
          onClick={clearCart}
        >
          Clear Cart
        </button>
       
      </div>


      <div style={{ flex: isMobile ? "none" : "2" }}>
  <div style={cardStyle}>
    {/* ✅ Fixed Header with Cart Icon */}
    <div
      style={{
        position: "sticky",
        top: 0,
        zIndex: 10,
        background: "#fff",
        padding: "10px 0",
        borderBottom: "1px solid #eee",
        textAlign: "right",
      }}
    >
      <div style={{ position: "relative", display: "inline-block" }}>
        <FaShoppingCart size={30} />
        {cartItems.length > 0 && (
          <span
            style={{
              position: "absolute",
              top: "-8px",
              right: "-8px",
              background: "red",
              color: "white",
              borderRadius: "50%",
              padding: "2px 6px",
              fontSize: "12px",
              fontWeight: "bold",
            }}
          >
            {cartItems.length}
          </span>
        )}
      </div>
      <span
        style={{
          marginLeft: "10px",
          fontSize: "20px",
          fontWeight: "600",
          color: "#333",
        }}
      >
        Your Cart
      </span>
    </div>

    {/* ✅ Empty Cart */}
    {cartItems.length === 0 ? (
      <div
        style={{
          textAlign: "center",
          padding: "40px 20px",
          color: "#888",
          fontSize: "18px",
        }}
      >
        Your cart is empty.
      </div>
    ) : (
      <div>
        {/* ✅ Table Header */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "2fr 1fr 1fr 1fr 1fr 0.5fr",
            padding: "12px 0",
            borderBottom: "2px solid #ddd",
            fontWeight: "700",
            fontSize: "14px",
            color: "#555",
            textAlign: "center",
          }}
        >
          <div style={{ textAlign: "left" }}>Package Name</div>
          <div>Type</div>
          <div> Per plate price</div>
          <div>Quantity</div>
          <div>Total</div>
          <div>Action</div>
        </div>

        {/* ✅ Table Rows */}
        {cartItems.map((item) => (
          <div
            key={item.id}
            style={{
              display: "grid",
              gridTemplateColumns: "2fr 1fr 1fr 1fr 1fr 0.5fr",
              padding: "16px 0",
              borderBottom: "1px solid #f0f0f0",
              alignItems: "center",
              textAlign: "center",
            }}
          >
            {/* Package Name */}
            <div style={{ textAlign: "left" }}>
              <div
                style={{ fontWeight: "600", fontSize: "16px", color: "#333" }}
              >
                {item.name}
              </div>
            </div>

            {/* Package Type */}
            <div>
              <span
                style={{
                  display: "inline-block",
                  padding: "4px 10px",
                  borderRadius: "12px",
                  fontSize: "12px",
                  fontWeight: "600",
                  color: "#fff",
                  background:
                    item.packageType.toLowerCase() === "veg"
                      ? "#28a745"
                      : "#dc3545",
                }}
              >
                {item.packageType}
              </span>
            </div>

            {/* Price per plate */}
            <div
              style={{ fontWeight: "700", fontSize: "16px", color: "#7d3fc2" }}
            >
              ₹{item.price.toFixed(2)}{" "}
              
            </div>

            {/* Quantity Controls */}
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "8px",
                alignItems: "center",
              }}
            >
              <button
                onClick={() => updateQty(item.id, -1)}
                style={{
                  width: "28px",
                  height: "28px",
                  borderRadius: "50%",
                  border: "1px solid #ddd",
                  background: "#fff",
                  fontWeight: "bold",
                  cursor: "pointer",
                }}
              >
                -
              </button>
              <span style={{ minWidth: "20px", fontWeight: "600" }}>
                {item.qty}
              </span>
              <button
                onClick={() => updateQty(item.id, 1)}
                style={{
                  width: "28px",
                  height: "28px",
                  borderRadius: "50%",
                  border: "1px solid #ddd",
                  background: "#fff",
                  fontWeight: "bold",
                  cursor: "pointer",
                }}
              >
                +
              </button>
            </div>

            {/* Total */}
            <div
              style={{ fontWeight: "700", fontSize: "16px", color: "#333" }}
            >
              ₹{(item.price * item.qty).toFixed(2)}
            </div>

            {/* Action */}
            <div>
              <button
                onClick={() => removeItem(item.id)}
                style={{
                  background: "transparent",
                  border: "none",
                  cursor: "pointer",
                  color: "red",
                  fontSize: "18px",
                }}
              >
                <FaTrash />
              </button>
            </div>
          </div>
        ))}
      </div>
    )}
  </div>




        {/* Order Summary Section */}
        <div style={{
          flex: isMobile ? "none" : "1",
          width: isMobile ? "100%" : "auto",
          position: isMobile ? "relative" : "sticky",
          top: isMobile ? "0" : "20px"
        }}>
          <div style={cardStyle}>
            <h2 style={{ marginTop: 0, marginBottom: "20px", color: "#333" }}>Order Summary</h2>

            <div style={{ marginBottom: "20px" }}>
              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "12px" }}>
                <span style={{ color: "#555" }}>Sub Total</span>
                <span style={{ fontWeight: "600" }}>₹{subTotal.toFixed(2)}</span>
              </div>

              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "12px" }}>
                <span style={{ color: "#555" }}>Platform Charges</span>
                <span style={{ fontWeight: "600" }}>₹{platformCharges.toFixed(2)}</span>
              </div>

              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "12px" }}>
                <span style={{ color: "#555" }}>Delivery Charges</span>
                <span style={{ fontWeight: "600" }}>₹{deliveryCharges.toFixed(2)}</span>
              </div>

              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "12px" }}>
                <label style={{ display: "flex", alignItems: "center", gap: "8px", color: "#555" }}>
                  <input
                    type="checkbox"
                    checked={discountApplied}
                    onChange={() => setDiscountApplied(p => !p)}
                    style={{ width: "18px", height: "18px" }}
                  />
                  Apply Discount (10%)
                </label>
                <div style={{ fontWeight: "600", color: "#28a745" }}>-₹{discountAmount.toFixed(2)}</div>
              </div>

              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "12px" }}>
                <span style={{ color: "#555" }}>CGST (9%)</span>
                <span style={{ fontWeight: "600" }}>₹{cgst.toFixed(2)}</span>
              </div>

              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "12px" }}>
                <span style={{ color: "#555" }}>SGST (9%)</span>
                <span style={{ fontWeight: "600" }}>₹{sgst.toFixed(2)}</span>
              </div>
            </div>

            <hr style={{ border: "none", borderTop: "1px dashed #ddd", margin: "16px 0" }} />

            <div style={{ display: "flex", justifyContent: "space-between", fontWeight: "700", fontSize: "20px", marginBottom: "8px" }}>
              <span style={{ color: "#333" }}>Grand Total</span>
              <span style={{ color: "#7d3fc2" }}>₹{grandTotal.toFixed(2)}</span>
            </div>

            <div style={{ textAlign: "right", fontSize: "14px", color: "#666", marginBottom: "20px" }}>
              Remaining: <strong style={{ color: remainingAmount > 0 ? "#dc3545" : "#28a745" }}>₹{(paymentCompleted ? 0 : (remainingAmount || grandTotal)).toFixed(2)}</strong>
            </div>

            {/* Order/Schedule buttons */}
            <div style={{
              display: "flex",
              flexDirection: isMobile ? "column" : "row",
              gap: "12px",
              marginTop: "20px"
            }}>
              <button
                onClick={handleOrderNow}
                disabled={isScheduled}
                style={{
                  ...buttonPrimaryStyle,
                  opacity: isScheduled ? 0.6 : 1,
                  width: isMobile ? "100%" : "auto"
                }}
                onMouseOver={(e) => {
                  if (!isScheduled) {
                    e.target.style.transform = "translateY(-2px)";
                    e.target.style.boxShadow = "0 6px 20px rgba(177, 93, 198, 0.4)";
                  }
                }}
                onMouseOut={(e) => {
                  if (!isScheduled) {
                    e.target.style.transform = "translateY(0)";
                    e.target.style.boxShadow = "0 4px 15px rgba(177, 93, 198, 0.3)";
                  }
                }}
              >
                Order Now
              </button>

              <button
                onClick={openScheduleModal}
                disabled={isOrdered}
                style={{
                  ...buttonSecondaryStyle,
                  opacity: isOrdered ? 0.6 : 1,
                  width: isMobile ? "100%" : "auto"
                }}
                onMouseOver={(e) => {
                  if (!isOrdered) {
                    e.target.style.background = "#ee6521";
                    e.target.style.color = "#fff";
                  }
                }}
                onMouseOut={(e) => {
                  if (!isOrdered) {
                    e.target.style.background = "transparent";
                    e.target.style.color = "#ee6521";
                  }
                }}
              >
                Schedule Order
              </button>
            </div>
          </div>

          {/* Payment Section */}
          {(showPaymentOptions || savedSchedule) && (
            <div ref={paymentSectionRef} style={{ ...cardStyle, marginTop: "20px" }}>
              <h3 style={{ marginTop: 0, marginBottom: "16px", color: "#333" }}>Payment Methods</h3>

              {savedSchedule && (
                <div style={{
                  background: "#f0f7ff",
                  padding: "12px 16px",
                  borderRadius: "8px",
                  marginBottom: "16px",
                  border: "1px solid #cce5ff"
                }}>
                  <div style={{ fontWeight: "600", color: "#004085", marginBottom: "4px" }}>
                    Order Scheduled
                  </div>
                  <div style={{ color: "#004085", fontSize: "14px" }}>
                    {savedSchedule.date} at {savedSchedule.time}
                  </div>
                </div>
              )}

              <div style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "10px",
                marginBottom: "20px"
              }}>
                {["wallet", "cash", "online"].map(m => (
                  <div
                    key={m}
                    onClick={() => selectPaymentMethod(m)}
                    style={{
                      padding: "12px 16px",
                      borderRadius: "12px",
                      border: `2px solid ${selectedPaymentMethod === m ? "#ee6521" : "#ddd"}`,
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      background: selectedPaymentMethod === m ? "#f9f0ff" : "#fff",
                      flex: isMobile ? "1 0 calc(50% - 10px)" : "none",
                      transition: "all 0.2s ease"
                    }}
                  >
                    <div style={{
                      width: "20px",
                      height: "20px",
                      borderRadius: "50%",
                      border: `2px solid ${selectedPaymentMethod === m ? "#ee6521" : "#ddd"}`,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      background: selectedPaymentMethod === m ? "#ee6521" : "transparent"
                    }}>
                      {selectedPaymentMethod === m && (
                        <span style={{ color: "#fff", fontSize: "12px" }}>✓</span>
                      )}
                    </div>
                    <span style={{ textTransform: "capitalize", fontWeight: "500" }}>
                      {m}
                    </span>
                  </div>
                ))}
              </div>

              {selectedPaymentMethod && (
                <div style={{ marginTop: "16px" }}>
                  <div style={{
                    display: "flex",
                    gap: "16px",
                    marginBottom: "16px",
                    flexWrap: isMobile ? "wrap" : "nowrap"
                  }}>
                    <label style={{ display: "flex", alignItems: "center", gap: "8px", cursor: "pointer" }}>
                      <input
                        type="radio"
                        checked={paymentMode === "full"}
                        onChange={() => { setPaymentMode("full"); setPartialAmount(""); }}
                        style={{ width: "18px", height: "18px" }}
                      />
                      Full Pay
                    </label>

                    <label style={{ display: "flex", alignItems: "center", gap: "8px", cursor: "pointer" }}>
                      <input
                        type="radio"
                        checked={paymentMode === "partial"}
                        onChange={() => setPaymentMode("partial")}
                        style={{ width: "18px", height: "18px" }}
                      />
                      Partial Pay
                    </label>
                  </div>

                  {paymentMode === "partial" && (
                    <div style={{ marginBottom: "16px" }}>
                      <input
                        type="number"
                        placeholder="Enter partial amount"
                        value={partialAmount}
                        onChange={(e) => setPartialAmount(e.target.value)}
                        style={{
                          padding: "12px 16px",
                          border: "1px solid #ddd",
                          borderRadius: "8px",
                          width: "100%",
                          fontSize: "16px",
                          boxSizing: "border-box"
                        }}
                      />
                      <div style={{ fontSize: "14px", color: "#666", marginTop: "8px" }}>
                        Remaining after pay: ₹{((remainingAmount || grandTotal) - (Number(partialAmount) || 0)).toFixed(2)}
                      </div>
                    </div>
                  )}

                  <div style={{
                    display: "flex",
                    gap: "12px",
                    flexDirection: isMobile ? "column" : "row"
                  }}>
                    <button
                      onClick={handlePayNow}
                      style={{
                        ...buttonPrimaryStyle,
                        flex: 1,
                        background: paymentCompleted ? "#28a745" : "linear-gradient(90deg, #ee6521, #7d3fc2)"
                      }}
                      onMouseOver={(e) => {
                        e.target.style.transform = "translateY(-2px)";
                        e.target.style.boxShadow = "0 6px 20px rgba(177, 93, 198, 0.4)";
                      }}
                      onMouseOut={(e) => {
                        e.target.style.transform = "translateY(0)";
                        e.target.style.boxShadow = "0 4px 15px rgba(177, 93, 198, 0.3)";
                      }}
                    >
                      {paymentCompleted ? "Payment Complete" : "Pay Now"}
                    </button>

                    <button
                      onClick={handlePlaceOrder}
                      style={{
                        ...buttonSecondaryStyle,
                        flex: 1,
                        borderColor: paymentCompleted ? "#28a745" : "#ee6521",
                        color: paymentCompleted ? "#28a745" : "#ee6521"
                      }}
                      onMouseOver={(e) => {
                        e.target.style.background = paymentCompleted ? "#28a745" : "#ee6521";
                        e.target.style.color = "#fff";
                      }}
                      onMouseOut={(e) => {
                        e.target.style.background = "transparent";
                        e.target.style.color = paymentCompleted ? "#28a745" : "#ee6521";
                      }}
                    >
                      Place Order
                    </button>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>

      {/* Schedule Modal */}
      <Modal
        isOpen={isScheduleModalOpen}
        onRequestClose={closeScheduleModal}
        style={{
          overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
            padding: isMobile ? "16px" : "0"
          },
          content: {
            position: "relative",
            inset: "auto",
            maxWidth: "400px",
            width: "100%",
            borderRadius: "16px",
            padding: "24px",
            boxShadow: "0 10px 30px rgba(0, 0, 0, 0.2)"
          }
        }}
      >
        <h2 style={{ marginTop: 0, marginBottom: "20px", color: "#333" }}>Schedule Order</h2>

        <div style={{ display: "flex", flexDirection: "column", gap: "16px", marginBottom: "20px" }}>
          <div>
            <label style={{ display: "block", marginBottom: "8px", fontWeight: "500", color: "#555" }}>Date</label>
            <input
              type="date"
              value={selectedDate}
              onChange={e => setSelectedDate(e.target.value)}
              style={{
                padding: "12px 16px",
                borderRadius: "8px",
                border: "1px solid #ddd",
                width: "100%",
                fontSize: "16px",
                boxSizing: "border-box"
              }}
            />
          </div>

          <div>
            <label style={{ display: "block", marginBottom: "8px", fontWeight: "500", color: "#555" }}>Time</label>
            <input
              type="time"
              value={selectedTime}
              onChange={e => setSelectedTime(e.target.value)}
              style={{
                padding: "12px 16px",
                borderRadius: "8px",
                border: "1px solid #ddd",
                width: "100%",
                fontSize: "16px",
                boxSizing: "border-box"
              }}
            />
          </div>
        </div>

        <div style={{ display: "flex", gap: "12px", justifyContent: "flex-end" }}>
          <button
            onClick={closeScheduleModal}
            style={{
              ...buttonSecondaryStyle,
              padding: "10px 20px"
            }}
            onMouseOver={(e) => {
              e.target.style.background = "#ee6521";
              e.target.style.color = "#fff";
            }}
            onMouseOut={(e) => {
              e.target.style.background = "transparent";
              e.target.style.color = "#ee6521";
            }}
          >
            Cancel
          </button>

          <button
            onClick={handleSaveSchedule}
            style={{
              ...buttonPrimaryStyle,
              padding: "10px 20px"
            }}
            onMouseOver={(e) => {
              e.target.style.transform = "translateY(-2px)";
              e.target.style.boxShadow = "0 6px 20px rgba(177, 93, 198, 0.4)";
            }}
            onMouseOut={(e) => {
              e.target.style.transform = "translateY(0)";
              e.target.style.boxShadow = "0 4px 15px rgba(177, 93, 198, 0.3)";
            }}
          >
            Save
          </button>
        </div>
      </Modal>
    </div>
  );
}

